import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  assignHeaderWrapper: {
    display: 'inline-block',
    width: '97.5%',
  },
  assignHeader: {
    float: 'left',
  },
  editAssignment: {
    float: 'right',
  },
  sidePadding: {
    paddingLeft: `${pxToRem(8)} !important`,
    paddingRight: `${pxToRem(8)} !important`,
  },
  advanceGroupName: {
    button: {
      height: 0,
    },
  },
  contractId: {
    marginTop: pxToRem(10),
    fontWeight: 400,
    float: 'right',
  },
  messageBarBody: {
    display: 'block',
    color: theme.palette.neutralDark,
    fontWeight: 400,
  },
});
